export default "/kiban/_next/static/images/search-a2019e10665f2b8cf0a2ecb98ff9e5f4.png";